import { KeyboardKey } from '../types';

export const HEBREW_ENGLISH_KEYBOARD: KeyboardKey[][] = [
    [
        { he: 'ק', en: 'E' }, { he: 'ר', en: 'R' },
        { he: 'א', en: 'T' }, { he: 'ט', en: 'Y' }, { he: 'ו', en: 'U' }, { he: 'ן', en: 'I' },
        { he: 'ם', en: 'O' }, { he: 'פ', en: 'P' }
    ],
    [
        { he: 'ש', en: 'A' }, { he: 'ד', en: 'S' }, { he: 'ג', en: 'D' }, { he: 'כ', en: 'F' },
        { he: 'ע', en: 'G' }, { he: 'י', en: 'H' }, { he: 'ח', en: 'J' }, { he: 'ל', en: 'K' },
        { he: 'ך', en: 'L' }, { he: 'ף', en: ';' }
    ],
    [
        { he: 'ז', en: 'Z' }, { he: 'ס', en: 'X' }, { he: 'ב', en: 'C' }, { he: 'ה', en: 'V' },
        { he: 'נ', en: 'B' }, { he: 'מ', en: 'N' }, { he: 'צ', en: 'M' }, { he: 'ת', en: ',' },
        { he: 'ץ', en: '.' }
    ],
    [
        { he: ' ', en: 'SPACE' }
    ]
];